<template>
  <app-layout title="Organisation Detail">
    <section class="fulls">
      <div class="container">
        <div class="w-3/4 starte">
          <h4 class="font-medium text-gray-600">Organisation Detail</h4>
          <p class="text-sm text-gray-400">
            Please fill the Information below:
          </p>
        </div>
        <div
          class="block w-3/4 rounded-lg px-5 py-5 border starte"
          style="background-color: rgb(249, 249, 249)"
        >
          <!-- <h5 class="text-gray-600">Organisation</h5> -->

          <div class="mt-2 mb-2 px-3">
            <BsOnBoardForm
              :createDef="this.organisationDef"
              @is_gst="handleGstChange"
              @is_multi="handleCustomChange"
              ref="organisationRef"
            />
          </div>
        </div>

        <div class="flex justify-between w-3/4 starte my-3">
          <div class="text-sm text-gray-500">
            <!-- <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
            &nbsp; Back to Previous Page -->
          </div>
          <button
            @click="goToNext()"
            type="button"
            class="inline-block px-4 py-1 rounded text-md font-semibold text-white"
            style="background-color: #6264c9"
          >
            Next
          </button>
        </div>
      </div>
    </section>
  </app-layout>
</template>

<script>
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import AppLayout from "@/Layouts/AppLayout.vue";

export default {
  props: {
    organisationDef: {
      type: Array,
      default: [],
    },
  },
  methods: {
    goToNext(){
      console.log("Organisation Ref",this.$refs.organisationRef.formData);

     this.$inertia.post(route("tenant-setups.orgsave","admin" ),this.$refs.organisationRef.formData);

      //alert( this.$refs.organisationRef.formData);
    }
  },

  components: {
    AppLayout,
    BsOnBoardForm,
  },
};
</script>

<style>
.fulls {
  background-color: #efeff1 !important;
  height: 89.5vh;
  background-size: cover;
  overflow: hidden;
  padding-top: 3rem;
}
.starte {
  margin: auto;
}
h3,
h6 {
  margin-bottom: 0.1rem;
}
</style>